import { render, staticRenderFns } from "./disposalProposalCow.vue?vue&type=template&id=a1bf3af4&scoped=true&"
import script from "./disposalProposalCow.vue?vue&type=script&lang=js&"
export * from "./disposalProposalCow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bf3af4",
  null
  
)

export default component.exports